export default __webpack_public_path__ + "static/media/IPS.1afb3acb.png";